// 自定义事件名称
const RECENTLY_OPENED_UPDATED_EVENT = 'recentlyOpenedUpdated';

// 触发自定义事件
const dispatchRecentlyOpenedUpdated = () => {
  window.dispatchEvent(new CustomEvent(RECENTLY_OPENED_UPDATED_EVENT));
};

export function loadRecentlyOpened() {
  try {
    const data = localStorage.getItem('recently_opened');
    return data ? JSON.parse(data) : [];
  } catch (e) {
    console.error('加载失败:', e);
    return [];
  }
}

export function saveRecentlyOpened(items) {
  try {
    localStorage.setItem('recently_opened', JSON.stringify(items));
    // 触发自定义事件通知更新
    dispatchRecentlyOpenedUpdated();
  } catch (e) {
    console.error('保存失败:', e);
  }
}

export function addRecentItem(newItem) {
  const MAX_RECENTS = 5;
  const prev = loadRecentlyOpened();
  // 从列表中移除已存在的同ID项目
  const filtered = prev.filter((x) => x.id !== newItem.id);
  // 最新访问插入到头部，并截取前5条
  const updated = [newItem, ...filtered].slice(0, MAX_RECENTS);
  saveRecentlyOpened(updated);
  return updated;
}

export function removeRecentItem(itemId) {
  const prev = loadRecentlyOpened();
  const updated = prev.filter((x) => x.id !== itemId);
  saveRecentlyOpened(updated);
  return updated;
}

// 导出事件名称供其他组件使用
export { RECENTLY_OPENED_UPDATED_EVENT };
